var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.83398H10.5V5.50065H15.5V3.83398ZM12.1667 14.6673H13.8333V9.66732H12.1667V14.6673ZM18.8583 9.15898L20.0417 7.97565C19.6833 7.55065 19.2917 7.15065 18.8667 6.80065L17.6833 7.98398C16.3917 6.95065 14.7667 6.33398 13 6.33398C8.85833 6.33398 5.5 9.69232 5.5 13.834C5.5 17.9757 8.85 21.334 13 21.334C17.15 21.334 20.5 17.9757 20.5 13.834C20.5 12.0673 19.8833 10.4423 18.8583 9.15898ZM13 19.6673C9.775 19.6673 7.16667 17.059 7.16667 13.834C7.16667 10.609 9.775 8.00065 13 8.00065C16.225 8.00065 18.8333 10.609 18.8333 13.834C18.8333 17.059 16.225 19.6673 13 19.6673Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusExpired);
export default __webpack_public_path__ + "static/media/statusExpired.9f8176398fb57fc480f2ba7fd4869374.svg";
export { ForwardRef as ReactComponent };